import { render, staticRenderFns } from "./AutomationBuilderHeader.vue?vue&type=template&id=7f066044&scoped=true"
import script from "./AutomationBuilderHeader.vue?vue&type=script&lang=js"
export * from "./AutomationBuilderHeader.vue?vue&type=script&lang=js"
import style0 from "./AutomationBuilderHeader.vue?vue&type=style&index=0&id=7f066044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f066044",
  null
  
)

export default component.exports